/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_NameInputs */

const vi_product_name = /** @type {(inputs: Product_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên sản phẩm`)
};

/**

* @param {Product_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_name = /** @type {((inputs?: Product_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_name(inputs)
});